import { render, staticRenderFns } from "./viewConfirmation.vue?vue&type=template&id=18773794"
import script from "./viewConfirmation.vue?vue&type=script&lang=js"
export * from "./viewConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports